/* Serene — universal PDP additions: scroll reveal, bundle selector, zoom lightbox, accordion */
(function () {
  'use strict';

  /* ---- Scroll reveal ----
     Arming and observing happen together, on purpose. serene-pdp-ext.css only
     hides [data-reveal] beneath .serene-armed, so if this file is blocked or
     throws before this point the content just stays visible rather than being
     stranded at opacity 0 — which is what silently hid the product
     description when this logic still lived in serene-pdp.js. */
  (function () {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('serene-armed');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-revealed');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '0px 0px -10% 0px' });

    for (var i = 0; i < els.length; i++) io.observe(els[i]);

    /* Sections re-rendered in the theme editor arrive unobserved, and would
       otherwise stay hidden for the merchant editing the page. */
    document.addEventListener('shopify:section:load', function (e) {
      var fresh = e.target.querySelectorAll('[data-reveal]');
      for (var j = 0; j < fresh.length; j++) io.observe(fresh[j]);
    });
  })();

  /* ---- Bundle / volume selector ---- */
  var bundle = document.querySelector('[data-serene-bundle]');
  var qtyInput = document.querySelector('[data-qty-input]');

  if (bundle && qtyInput) {
    var cards = bundle.querySelectorAll('[data-bundle-qty]');

    function selectCard(card) {
      for (var i = 0; i < cards.length; i++) cards[i].classList.remove('is-selected');
      card.classList.add('is-selected');
      qtyInput.value = parseInt(card.getAttribute('data-bundle-qty'), 10) || 1;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    for (var c = 0; c < cards.length; c++) {
      (function (card) {
        card.addEventListener('click', function () { selectCard(card); });
      })(cards[c]);
    }

    /* If the shopper edits quantity by hand, highlight the matching card (or none) */
    function syncFromQty() {
      var n = parseInt(qtyInput.value, 10) || 1;
      var matched = false;
      for (var i = 0; i < cards.length; i++) {
        var on = parseInt(cards[i].getAttribute('data-bundle-qty'), 10) === n;
        cards[i].classList.toggle('is-selected', on);
        if (on) matched = true;
      }
      if (!matched) {
        for (var j = 0; j < cards.length; j++) cards[j].classList.remove('is-selected');
      }
    }
    qtyInput.addEventListener('input', syncFromQty);

    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setTimeout(syncFromQty, 0); });
    if (plus) plus.addEventListener('click', function () { setTimeout(syncFromQty, 0); });
  }

  /* ---- Zoom lightbox ---- */
  var zoom = document.querySelector('[data-zoom]');
  if (zoom) {
    var zoomImg = zoom.querySelector('[data-zoom-img]');
    var openers = document.querySelectorAll('[data-open-zoom]');
    var stage = document.querySelector('.serene-pdp__stage');

    function currentImage() {
      var active = document.querySelector('.serene-pdp__slide.is-active img');
      return active ? active.src : null;
    }

    function openZoom() {
      var src = currentImage();
      if (!src || !zoomImg) return;
      zoomImg.src = src;
      if (typeof zoom.showModal === 'function') zoom.showModal();
      else zoom.setAttribute('open', '');
    }
    function closeZoom() {
      if (typeof zoom.close === 'function') zoom.close();
      else zoom.removeAttribute('open');
    }

    for (var o = 0; o < openers.length; o++) openers[o].addEventListener('click', openZoom);

    /* Clicking the main image also zooms */
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('.serene-pdp__arrow') || e.target.closest('[data-open-zoom]')) return;
        if (e.target.tagName === 'IMG') openZoom();
      });
    }

    var closers = zoom.querySelectorAll('[data-close-modal]');
    for (var cl = 0; cl < closers.length; cl++) closers[cl].addEventListener('click', closeZoom);
    zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
  }

  /* ---- Accordion: one row open at a time ---- */
  var acc = document.querySelector('[data-serene-acc]');
  if (acc) {
    var items = acc.querySelectorAll('details');
    for (var a = 0; a < items.length; a++) {
      (function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          for (var k = 0; k < items.length; k++) {
            if (items[k] !== item) items[k].open = false;
          }
        });
      })(items[a]);
    }
  }
})();